/* tslint:disable */
/* eslint-disable */
/**
 * File API
 * API for managing files
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * État d'un justificatif attendu sur un devis (relevé d'information de sinistralité…)
 * @export
 * @interface DevisDocumentInfoResponse
 */
export interface DevisDocumentInfoResponse {
    /**
     * Vrai quand le justificatif est déposé et porte une version courante
     * @type {boolean}
     * @memberof DevisDocumentInfoResponse
     */
    _exists?: boolean;
    /**
     * Fichier stocké de la version courante (retrait, visualisation)
     * @type {string}
     * @memberof DevisDocumentInfoResponse
     */
    storedFileId?: string | null;
    /**
     * Nom du fichier déposé
     * @type {string}
     * @memberof DevisDocumentInfoResponse
     */
    fileName?: string | null;
    /**
     * URL temporaire de consultation (1 h)
     * @type {string}
     * @memberof DevisDocumentInfoResponse
     */
    url?: string | null;
}

/**
 * Check if a given object implements the DevisDocumentInfoResponse interface.
 */
export function instanceOfDevisDocumentInfoResponse(value: object): value is DevisDocumentInfoResponse {
    return true;
}

export function DevisDocumentInfoResponseFromJSON(json: any): DevisDocumentInfoResponse {
    return DevisDocumentInfoResponseFromJSONTyped(json, false);
}

export function DevisDocumentInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevisDocumentInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        '_exists': json['exists'] == null ? undefined : json['exists'],
        'storedFileId': json['storedFileId'] == null ? undefined : json['storedFileId'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function DevisDocumentInfoResponseToJSON(json: any): DevisDocumentInfoResponse {
    return DevisDocumentInfoResponseToJSONTyped(json, false);
}

export function DevisDocumentInfoResponseToJSONTyped(value?: DevisDocumentInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exists': value['_exists'],
        'storedFileId': value['storedFileId'],
        'fileName': value['fileName'],
        'url': value['url'],
    };
}

